import actions from "./actions";

const initState = {
  shifts: [],
  suspiciousShifts: [],
};

export default function shiftsReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_ALL_SHIFT:
      return {
        ...state,
        shifts: action.payload,
      };
    case actions.SET_SUSPICIOUS_SHIFTS:
      return {
        ...state,
        suspiciousShifts: action.payload,
      };
    default:
      return state;
  }
}
